import React, { useEffect, type FC } from 'react'

import { useRouteError } from 'react-router-dom'

import { PageHeader } from 'mailup-web-components'

import { logAppError } from 'Helpers/logger'

import Page from 'Containers/Page'

const ErrorBoundaryReactRouterV6: FC = (props) => {
  const error = useRouteError()

  useEffect(() => {
    if (error instanceof Error) {
      logAppError({
        appError: error,
      })
    }
  }, [error])

  return (
    <>
      <PageHeader breadcrumbsItems={[]} />
      <Page onReload={() => {}} />
    </>
  )
}

export default ErrorBoundaryReactRouterV6
